export default "__VITE_ASSET__DZAf5Jao__"